import React from "react";

const FilledCheckIcon = ({
  fill = "",
  size = "",
}: {
  fill?: string | null;
  size?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size || "24"}
      height={size || "24"}
      fill={fill || "#198754"}
    >
      <path d="M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm114.29 150.29l-128 128a16 16 0 01-22.58 0l-64-64a16 16 0 0122.58-22.58L231 292.69l116.69-116.68a16 16 0 0122.6 22.57z" />
    </svg>
  );
};

export default FilledCheckIcon;
